// removed by extract-text-webpack-plugin
module.exports = {"root":"options-sidebar--root--3e7nzVxv","option":"options-sidebar--option--3LJjVk7h","active":"options-sidebar--active--2qt37gJc","name":"options-sidebar--name--1_gTASe_"};


//////////////////
// WEBPACK FOOTER
// ./components/options-sidebar/styles.css
// module id = ./components/options-sidebar/styles.css
// module chunks = 0